const types = {
	FETCH_BID_START: 'FETCH_BID_START',
	FETCH_BID_ERROR: 'FETCH_BID_ERROR',
	FETCH_BID_SUCCESS: 'FETCH_BID_SUCCESS',
	UPDATE_BID_START: 'UPDATE_BID_START',
	UPDATE_BID_ERROR: 'UPDATE_BID_ERROR',
	UPDATE_BID_SUCCESS: 'UPDATE_BID_SUCCESS',
	DELETE_BID_START: 'DELETE_BID_START',
	DELETE_BID_ERROR: 'DELETE_BID_ERROR',
	DELETE_BID_SUCCESS: 'DELETE_BID_SUCCESS',
	RESET_ALL: 'RESET_ALL'
}

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/bid-form/mutation-types.js